<template>
  <div id="Art" class="container-xl">
    <h2 class="componentheader">Art</h2>
    <p>My doodling of different characters from games. Most of them are inspired by my gameplay or experience while playing the game.</p>
    <div class="container-xl">
      <div class="row">
        <div class="thumbnails col-md-6 col-lg-4"
          v-for="(thumbnail, index) in thumbnails"
          :key="thumbnail.thumbnailId"
          @click="showModal(index)"
        >
        <img v-lazy="thumbnail.url" :alt="thumbnail.title"/>
        </div>
      </div>
    </div>
    <lgImageModal v-model="modalShow" :selectedUrl="selectedUrl"></lgImageModal>
  </div>
</template>

<script>
import lgImageModal from '@/components/lgImageModal.vue'
import db from '@/db'

export default {
  name: 'Art',
  components: {
    lgImageModal
  },
  data () {
    return {
      modalShow: false,
      selectedImg: 0,
      selectedUrl: '',
      thumbnails: []
    }
  },
  created () {
    db.collection('art').get().then(snapshot => {
      snapshot.forEach(doc => {
        const thumbnailId = doc.id
        const title = doc.data().title
        const url = 'static/images/' + doc.data().url
        const thumbnail = {
          thumbnailId,
          title,
          url
        }

        this.thumbnails.push(thumbnail)
      })
    })
  },
  methods: {
    showModal: function (index) {
      this.selectedImg = index
      this.selectedUrl = this.thumbnails[this.selectedImg].url
      this.modalShow = !this.modalShow
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.thumbnails img {
  width: 100%;
  margin-bottom: 1.5em;
  border-radius: 7%;
  box-shadow: 5px 5px rgba(0,0,0,.2);
}

.thumbnails img:hover, .thumbnails img:focus {
  transform: scale(1.1);
  transition-duration: .5s;
  cursor: pointer;
  box-shadow: 10px 10px rgba(193,241,0,1);
}

</style>



// WEBPACK FOOTER //
// src/components/Art.vue